// extracted by mini-css-extract-plugin
module.exports = {"SectionImageText2":"SectionImageText_SectionImageText2__ZhdYv"};